<script setup>
    import { reactive, onMounted, watch } from 'vue'
    import { ref as databaseRef, onValue, update } from "firebase/database";
    import { ref as storageRef, uploadBytes } from "firebase/storage";
    import { useRoute } from 'vue-router'
    import HeaderComponent from '../../components/common/HeaderComponent.vue'
    import NavigationBar from '../../components/business/NavigationBar.vue'
    import DefaultModalComponent from '../../components/common/DefaultModalComponent.vue'
    import Firebase from "../../firebase_settings/index.js"
    import utilFunctions from "../../firebase_settings/utils.js"
    import Error from "../../firebase_settings/error.js"

    const auth = Firebase.auth
    const database = Firebase.database;
    const storage = Firebase.storage;
    const route = useRoute()

    //アプリ設定情報のリアクティブオブジェクト
    const reactiveObj = reactive({
        //利用者の姓名を利用するかを判別するフラグ
        UseName1: false,
        //利用者のセイメイを利用するかを判別するフラグ
        UseName2: false,
        //企業名
        CorporateName: "",
        //企業ロゴファイル名
        LogoPath: "",
        //端末側のタイムアウト時間
        Timeout: 10,
        //最終更新日時
        LatestUpdated: 0,
        //夜間施錠実施フラグ
        NightFlag: false,
        //夜間施錠の開始時間
        NightStart: 0,
        //夜間施錠の終了時間
        NightEnd: 0,
    })
    const reactiveNightObj = reactive({
        startHour: 0,
        startMinute: 0,
        endHour: 0,
        endMinute: 0,
    })
    //再描画用のリアクティブオブジェクト
    const reactiveRender = reactive({
        //再描画用のキー
        renderKey: 0
    })
    //モーダルウィンドウ関連のリアクティブオブジェクト
    const reactiveModalObj = reactive({
        //モーダル開閉
        modalFlag: false,
        //モーダルに表示するメッセージ
        modalMessage: "",
        //モーダルの再描画用のキー
        modalRenderkey: 0
    })
    //既に設定されているアプリ情報
    let beforeInfo = {}
    //企業用コード
    let corporateId = ""
    //企業ロゴ
    let logofile = 0
    //firebaseからアプリ情報を取得
    const getSettings = async (corporateId) => {
        const settingsRef = databaseRef(database, `CorporateId/${corporateId}/AppSettings`)
        //firebaseからアプリ情報を取得する
        onValue(settingsRef, (snapshot) => {
            const settings = (snapshot.val())
            for(let settingKey in settings) {
                reactiveObj[settingKey] = settings[settingKey]
            }
            reactiveNightObj.startHour = Math.floor(reactiveObj.NightStart / 100)
            reactiveNightObj.startMinute = reactiveObj.NightStart % 100
            reactiveNightObj.endHour = Math.floor(reactiveObj.NightEnd / 100)
            reactiveNightObj.endMinute = reactiveObj.NightEnd % 100
            beforeInfo = settings
        })
    }
    //画像アップロード処理
    const imageUpload = (e) => {
        const logo = e.target.files
        //対応拡張子を.jpeg .jpg .pngにバリデーション
        const regexp = new RegExp(/.*\.jpg$|.*\.jpeg$|.*\.png$/, 'i')
        //サイズチェック(10MB以下)
        try {
            //拡張子チェッカー
            if(regexp.test(logo[0]['name']) && logo[0]['size'] <= 10485760) {
                //アップロード可能な画像がある場合、ラベル名を変更
                document.getElementById("imageLabel").innerHTML = '選択済';
                //設定ボタンを有効化させる
                inputSomeData()
                //企業ロゴの格納
                logofile = logo[0]
            }
            //指定拡張子以外のファイルの場合
            else {
                alert(Error.errorResult({ code: 'ASE0001'}, route.name))
                document.getElementById("imageLabel").innerHTML = '画像選択';
                reactiveRender.renderKey++
                return
            }
        }
        //ファイル読み込みエラー時
        catch {
            alert(Error.errorResult({ code: 'ASE0002'}, route.name))
            document.getElementById("imageLabel").innerHTML = '画像選択';
            reactiveRender.renderKey++
            return
        }
    }
    //データ入力時に実行
    const inputSomeData = () => {
        //入力があった項目を更新
        let equalFlag = false
        for(let key in reactiveObj){
            //以下の条件でTrueとなる
            //１．入力があった項目が前の情報と異なる場合
            //２．画像が選択されている場合
            if(beforeInfo[key] != reactiveObj[key] && key != 'LatestUpdated' || document.getElementById("imageLabel").innerHTML == '選択済'){
                equalFlag = true
                break
            }
        }

        //活性判定フラグTrueなら変更ボタンを活性化そうでないなら非活性化
        equalFlag ? document.getElementById('commonButton').disabled = false: document.getElementById('commonButton').disabled = true
    }
    //モーダルウィンドウを開く際に実行
    const showDefaultModal = (message) => {
        //モーダルを表示
        reactiveModalObj.modalFlag= true
        //モーダル上の表示する文面
        reactiveModalObj.modalMessage = message
        //モーダル部分を再描画
        reactiveModalObj.modalRenderkey++
    }
    //モーダルウィンドウを閉じる際に実行
    const closeDefaultModal = async (editFlag) => {
        //モーダルウィンドウを閉じる
        reactiveModalObj.modalFlag= false
        if(editFlag) {
            //画像が選択済の場合
            if(document.getElementById("imageLabel").innerHTML == '選択済') {
                const metadata = {
                    contentType: reactiveObj.LogoPath.match(/.*\.jpg$|.*\.jpeg$/i) ? 'image/jpeg':
                        reactiveObj.LogoPath.match(/.*\.png$/i) ? 'image/png' : ""
                };
                reactiveObj.LogoPath = logofile.name
                const uploadPath = `/${corporateId}/Logo/`
                const uploadref = storageRef(storage, `${uploadPath}${reactiveObj.LogoPath}`)
                //画像をFirebaseにアップロード
                await uploadBytes(uploadref, logofile, metadata)
            }
            //タイムアウトの値を数値に変換
            reactiveObj.Timeout = Number(reactiveObj.Timeout)
            //各種状態をリセット
            document.getElementById('commonButton').disabled = false
            document.getElementById("imageLabel").innerHTML = '画像選択';
            reactiveRender.renderKey++

            //Firebase RTDBの値を更新
            const settingsRef = databaseRef(database, `CorporateId/${corporateId}/AppSettings`)
            reactiveObj.LatestUpdated = Date.now()
            update(settingsRef, reactiveObj);
        }
    }
    //HHMMの形式に合わせて4桁の数値でそれぞれ開始と終了の値を計算する
    const setNightTime = (setSpan) => {
        setSpan == 'start' ? reactiveObj.NightStart = Number(reactiveNightObj.startHour * 100) + Number(reactiveNightObj.startMinute):
            reactiveObj.NightEnd = Number(reactiveNightObj.endHour * 100) + Number(reactiveNightObj.endMinute)
    }
    //コンポーネントがマウントされた後に実行
    onMounted(async () => {
        //企業コードの取得
        corporateId = await utilFunctions.getCorporateId()
        //アプリ情報を取得する
        await getSettings(corporateId)
    })
    //リアクティブオブジェクトの監視
    watch((reactiveObj), () => {
        inputSomeData()
    })
</script>

<template>
    <HeaderComponent></HeaderComponent>
    <NavigationBar></NavigationBar>
    <main>
        <div class="appSettings" :key="reactiveRender.renderKey">
            <div class="titleArea">
                <p class="title">アプリ設定</p>
            </div>
            <table class="commonTable">
                <tbody>
                    <tr>
                        <th class="firstTd halfTh"></th>
                        <th></th>
                    </tr>
                    <tr>
                        <td class="firstTd">　利用者の姓名を利用する</td>
                        <td class="firstTd">
                            <div class="switchArea">
                                <p class="switchLabel" v-if = "reactiveObj.UseName1">ON</p>
                                <p class="switchLabel" v-else>OFF</p>
                                <label>
                                    <input type="checkbox" v-model="reactiveObj.UseName1">
                                    <div id="swImg"></div>
                                </label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="firstTd">　利用者の姓名(フリガナ)を利用する</td>
                        <td class="firstTd">
                            <div class="switchArea">
                                <p class="switchLabel" v-if = "reactiveObj.UseName2">ON</p>
                                <p class="switchLabel" v-else>OFF</p>
                                <label>
                                    <input type="checkbox" v-model="reactiveObj.UseName2">
                                    <div id="swImg"></div>
                                </label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="firstTd notButtom">　企業ロゴ・企業名</td>
                        <td class="firstTd notButtom"><label id="imageLabel">画像選択<input type="file" id="imageButton" @change="imageUpload"></label></td>
                    </tr>
                    <tr>
                        <td class="firstTd notTop" colspan="2"><input type="text" id="inputCorporate" v-model="reactiveObj.CorporateName" placeholder="企業名"></td>
                        <td class="firstTd notTop"></td>
                    </tr>
                    <tr>
                        <td class="firstTd notButtom">　夜間施錠を利用する</td>
                        <td class="firstTd notButtom">
                            <div class="switchArea">
                                <p class="switchLabel" v-if = "reactiveObj.NightFlag">ON</p>
                                <p class="switchLabel" v-else>OFF</p>
                                <label>
                                    <input type="checkbox" v-model="reactiveObj.NightFlag">
                                    <div id="swImg"></div>
                                </label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="firstTd notTop" colspan="2">
                            <div class="setNightTime">
                                <select class="setTime setStartHour" v-model="reactiveNightObj.startHour" v-bind:disabled="!reactiveObj.NightFlag" @change="setNightTime('start')">
                                    <option value="0">00時</option>
                                    <option value="1">01時</option>
                                    <option value="2">02時</option>
                                    <option value="3">03時</option>
                                    <option value="4">04時</option>
                                    <option value="5">05時</option>
                                    <option value="6">06時</option>
                                    <option value="7">07時</option>
                                    <option value="8">08時</option>
                                    <option value="9">09時</option>
                                    <option value="10">10時</option>
                                    <option value="11">11時</option>
                                    <option value="12">12時</option>
                                    <option value="13">13時</option>
                                    <option value="14">14時</option>
                                    <option value="15">15時</option>
                                    <option value="16">16時</option>
                                    <option value="17">17時</option>
                                    <option value="18">18時</option>
                                    <option value="19">19時</option>
                                    <option value="20">20時</option>
                                    <option value="21">21時</option>
                                    <option value="22">22時</option>
                                    <option value="23">23時</option>
                                </select>
                                <select class="setTime setStartMinute" v-model="reactiveNightObj.startMinute" v-bind:disabled="!reactiveObj.NightFlag" @change="setNightTime('start')">
                                    <option value="0">00分</option>
                                    <option value="15">15分</option>
                                    <option value="30">30分</option>
                                    <option value="45">45分</option>
                                </select>
                                <p class="whiteSpace">～</p>
                                <select class="setTime setEndHour" v-model="reactiveNightObj.endHour" v-bind:disabled="!reactiveObj.NightFlag" @change="setNightTime('end')">
                                    <option value="0">00時</option>
                                    <option value="1">01時</option>
                                    <option value="2">02時</option>
                                    <option value="3">03時</option>
                                    <option value="4">04時</option>
                                    <option value="5">05時</option>
                                    <option value="6">06時</option>
                                    <option value="7">07時</option>
                                    <option value="8">08時</option>
                                    <option value="9">09時</option>
                                    <option value="10">10時</option>
                                    <option value="11">11時</option>
                                    <option value="12">12時</option>
                                    <option value="13">13時</option>
                                    <option value="14">14時</option>
                                    <option value="15">15時</option>
                                    <option value="16">16時</option>
                                    <option value="17">17時</option>
                                    <option value="18">18時</option>
                                    <option value="19">19時</option>
                                    <option value="20">20時</option>
                                    <option value="21">21時</option>
                                    <option value="22">22時</option>
                                    <option value="23">23時</option>
                                </select>
                                <select class="setTime setEndMinute" v-model="reactiveNightObj.endMinute" v-bind:disabled="!reactiveObj.NightFlag" @change="setNightTime('end')">
                                    <option value="0">00分</option>
                                    <option value="15">15分</option>
                                    <option value="30">30分</option>
                                    <option value="45">45分</option>
                                </select>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="firstTd">　タイムアウト時間</td>
                        <td class="firstTd">
                            <select id="timeoutButton" v-model="reactiveObj.Timeout">
                                <option value="1">1分</option>
                                <option value="3">3分</option>
                                <option value="5">5分</option>
                                <option value="10">10分</option>
                                <option value="20">20分</option>
                                <option value="30">30分</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td class="updateArea notButtom" colspan="2"><button id="commonButton" @click="showDefaultModal(`入力した内容で設定します。<br>よろしいですか？`)" disabled>設定する</button></td>
                    </tr>
                </tbody>
            </table>
            <DefaultModalComponent
                :key="reactiveModalObj.modalRenderkey"
                :modalMessage="reactiveModalObj.modalMessage"
                v-show="reactiveModalObj.modalFlag"
                @executeMethod="closeDefaultModal">
            </DefaultModalComponent>
        </div>
    </main>
</template>

<style scoped>
    .appSettings {
        padding: 0 5% 0 25%;
        background-color: #e7e6e6;
    }
    .commonTable td {
        height: 80px;
    }
    .noneTd {
        width: 10px;
        font-size: 16px;
    }
    .commonTable .updateArea {
        height: 150px;
    }
    .setNightTime {
        position: relative;
        height: 60%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 2%;
    }
    .setTime {
        height: 100%;
        width: 200px;
        text-align: center;
        border-radius: 10px;
        border: solid 2px #999999;
        background-color: #EEEEEF;
        margin: 0 4% 0 4%;
    }
    .setStartMinute {
        position: relative;
        left: -5%;
    }
    .setEndHour {
        position: relative;
        left: 5%;
    }
    #inputCorporate {
        height: 60%;
        width: calc(100% - (2.5% + 15px));
        margin: 0 0 0 15px;
        border-radius: 10px;
        border: solid 2px #999999;
        background-color: #EEEEEF;
    }
    #imageLabel {
        display: block;
        position: relative;
        border-radius: 10px;
        border: solid 2px #999999;
        background-color: #EEEEEF;
        width: 50%;
        height: 60%;
        text-align: center;
        line-height: 300%;
        left: 45%;
    }
    #fileLabel {
        display: block;
        position: relative;
        border-radius: 10px;
        border: solid 2px #999999;
        background-color: #EEEEEF;
        width: 50%;
        height: 60%;
        text-align: center;
        line-height: 300%;
        left: 45%;
    }
    #fileButton {
        display: none;
    }
    #imageButton {
        display: none;
    }
    #timeoutButton {
        position: relative;
        border-radius: 10px;
        border: solid 2px #999999;
        background-color: #EEEEEF;
        width: 51%;
        height: 60%;
        margin: 0 4% 0 45%;
        text-align: center;
    }
    #commonButton {
        width: 25%;
    }
    @media (max-width: 1150px) {
        .appSettings {
            padding: 0 5% 0 5%;
        }
        .firstTd {
            font-size: small;
        }
        .commonTable {
            width: 100%;
        }
        #commonButton {
            left: 25%;
            width: 50%;
        }
        .setNightTime {
            height: auto;
            text-align: left;
            display: block;
            justify-content: left;
            gap: 0%;
            padding: 0 0 15px 0;
        }
        .setTime {
            height: 48px;
            width: 130px;
        }
        .setStartMinute {
            position: relative;
            left: 0%;
        }
        .setEndHour {
            position: relative;
            left: 0%;
        }
        .whiteSpace {
            position: relative;
            left: 10%;
        }
    }
</style>
